/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_Work_OrderInputs */

const en_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish work order`)
};

const fr_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier le bon de travail`)
};

const de_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsauftrag veröffentlichen`)
};

const it_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblica ordine di lavoro`)
};

const ru_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовать наряд на выполнение работ`)
};

const es_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar orden de trabajo`)
};

const zh_cn2_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布工作单`)
};

const ja_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業指示書を公開する`)
};

const hi_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य आदेश प्रकाशित करें`)
};

const pt_pt2_publish_work_order = /** @type {(inputs: Publish_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar ordem de serviço`)
};

/**
* | output |
* | --- |
* | "Publish work order" |
*
* @param {Publish_Work_OrderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const publish_work_order = /** @type {((inputs?: Publish_Work_OrderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_Work_OrderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_publish_work_order(inputs)
	if (locale === "de") return de_publish_work_order(inputs)
	if (locale === "it") return it_publish_work_order(inputs)
	if (locale === "ru") return ru_publish_work_order(inputs)
	if (locale === "es") return es_publish_work_order(inputs)
	if (locale === "zh-CN") return zh_cn2_publish_work_order(inputs)
	if (locale === "ja") return ja_publish_work_order(inputs)
	if (locale === "hi") return hi_publish_work_order(inputs)
	if (locale === "pt-PT") return pt_pt2_publish_work_order(inputs)
	return en_publish_work_order(inputs)
});